<template>
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2 36C2 17.2223 17.2223 2 36 2C54.7777 2 70 17.2223 70 36C70 54.7777 54.7777 70 36 70C17.2223 70 2 54.7777 2 36ZM36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0ZM36 24C36.5523 24 37 24.4477 37 25V39C37 39.5523 36.5523 40 36 40C35.4477 40 35 39.5523 35 39V25C35 24.4477 35.4477 24 36 24ZM36 44C36.5523 44 37 44.4477 37 45V47C37 47.5523 36.5523 48 36 48C35.4477 48 35 47.5523 35 47V45C35 44.4477 35.4477 44 36 44Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'IconWarning',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
